import { useState, useRef, useCallback, useEffect } from "react";
function waitForImages(container) {
  const images = container.querySelectorAll("img");
  const promises = Array.from(images).map((img) => {
    if (img.complete) return Promise.resolve();
    return new Promise((resolve) => {
      img.onload = () => resolve();
      img.onerror = () => resolve();
    });
  });
  return Promise.all(promises).then(() => {
  });
}
function useQuizMeasurement(measureRef, quizScripts, deps) {
  const [measuredHeights, setMeasuredHeights] = useState([]);
  const [isMeasuring, setIsMeasuring] = useState(false);
  const counterRef = useRef(0);
  const measure = useCallback(() => {
    if (!measureRef.current || quizScripts.length === 0) {
      setMeasuredHeights([]);
      setIsMeasuring(false);
      return;
    }
    setIsMeasuring(true);
    const id = ++counterRef.current;
    requestAnimationFrame(() => {
      const container = measureRef.current;
      if (!container || id !== counterRef.current) return;
      waitForImages(container).then(() => {
        if (id !== counterRef.current) return;
        const items = container.querySelectorAll("[data-quiz-measure]");
        const heights = Array.from(items).map((el) => el.getBoundingClientRect().height);
        setMeasuredHeights(heights);
        setIsMeasuring(false);
      });
    });
  }, [measureRef, quizScripts]);
  useEffect(() => {
    measure();
  }, [measure, ...deps ?? []]);
  return { measuredHeights, isMeasuring, remeasure: measure };
}
export {
  useQuizMeasurement
};
//# sourceMappingURL=useQuizMeasurement.js.map
